export const EnvContribution = Symbol.for("EnvContribution");

export const VGlobal = Symbol.for("VGlobal");

export const DEFAULT_TEXT_FONT_FAMILY = "PingFang SC,Helvetica Neue,Microsoft Yahei,system-ui,'-apple-system',segoe ui,Roboto,Helvetica,Arial,sans-serif,apple color emoji,segoe ui emoji,segoe ui symbol";
//# sourceMappingURL=constants.js.map